import { encryptKey, encryptKeyPassword } from './parameter'
import cryptoJSObj from 'crypto-js';
import cryptoJS from 'crypto-js/aes';
import cryptoENC from 'crypto-js/enc-utf8';

export function encrypt(text, json = true) {
    let textToEncrypt = json ? JSON.stringify(text) : text;

    const key = encryptKey;

    const data = cryptoJS.encrypt(textToEncrypt, key).toString();

    return data;
}

export function decrypt(text, json = true) {
    const key = encryptKey;
    const bytes = cryptoJS.decrypt(text, key);

    const decryptedText = bytes.toString(cryptoENC);

    const data = json ? JSON.parse(decryptedText) : decryptedText;

    return data;
}

// We use this encryption to decrypt in C#
export function encryption(number) {
    var secret = encryptKeyPassword;

    var key = cryptoJSObj.enc.Utf8.parse(secret);
    var iv = cryptoJSObj.enc.Utf8.parse(secret);
    var encrypted = cryptoJS.encrypt(cryptoJSObj.enc.Utf8.parse(number), key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: cryptoJSObj.mode.CBC,
            padding: cryptoJSObj.pad.Pkcs7
        });
    return encrypted.toString().replaceAll('+', '*');
}